var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 11,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2153FD",
  d: "m1.21 10.412 5.271-4.187c.255-.239.455-.418.455-.725s-.17-.474-.455-.725L1.211.588a.83.83 0 0 0-.806.033.82.82 0 0 0-.405.691v8.376a.82.82 0 0 0 .406.69.83.83 0 0 0 .805.034"
})));
export { SvgNext as ReactComponent };
export default __webpack_public_path__ + "Next.65041587.svg";